<template>
  <button class="extra-wishes btn-extra-wishes" @click="click">
    <div class="mobile-edit">
      +
    </div>
    <span>Extra wensen</span>
  </button>
</template>

<script>
import PencilEdit from '../../../assets/icons/pencil_edit.svg?inline'

export default {
  name: 'ButtonExtraWishes',

  components: {
    PencilEdit
  },

  methods: {
    click() {
      this.$emit('click');
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../assets/sass/abstracts";

.extra-wishes {
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 1.5;
  text-transform: none;
  margin: 0 auto;
  border-radius: $border-radius;
  background-color: $white;
  justify-content: center;
}

.extra-wishes .mobile-edit {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  height: 24px;
  font-size: 18px;
}

.btn-extra-wishes {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  text-align: center;
  font-weight: bold;
  padding: 3px 8px 3px;
  width: max-content;
  color: var(--c-extra-wishes-btn);
  cursor: pointer;
}
</style>
